/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "api";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import Select from "react-select";
import i18n from "i18next";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {
    Table,
} from "react-bootstrap";
import TpeListDetails from "./TpeListDetails";

am4core.addLicense("ch-custom-attribution");
am4core.useTheme(am4themes_animated);


class TpeList extends Component {

    state = {
        Tpe: [],
        Tpematriss: [],
        questionSelectionTypes: [],
        isManager: localStorage.getItem("roles").includes("Manager"),
        selectedDepartment: null,
        selectedEmployee: null,
        employeeOptions: [],
        employees: [],
        chartRandom: null,
        group1id: "",
        group1name: "Bilgi",
        group2id: "",
        group2name: "Pts",
        group3id: "",
        group3name: "Uygulama",
    };

    componentDidMount() {
        this.getEmployees();
    }

    getEmployees = () => {
        api
            .get(`/api/employee-360/employees`)
            .then((response) => {
                this.setState({
                    employees: response.data.data.employees,
                });
            })
            .catch((err) => {
                console.error(err);
            });
    };


    componentDidUpdate(prevProps, prevState) {

        if (prevState.employees !== this.state.employees) {
            const currentEmployee = this.state.employees.find(
                (z) => z.id === this.props.profile.general.id
            );

            if (!currentEmployee) return;

            const currentEmployeeDepartment = this.deparmentOptions.find(
                (o) => o.value === String(currentEmployee.serviceType.value)
            );

            this.setState({
                selectedDepartment: currentEmployeeDepartment.value,
                selectedEmployee: currentEmployee.id,
            });

            this.getTpeList(currentEmployee.id);
            this.getTitle();
        }


        if (prevState.selectedDepartment !== this.state.selectedDepartment) {
            const employeesOfDepartment = this.state.employees.filter(
                (z) => z.serviceType.value === parseInt(this.state.selectedDepartment)
            );
            const _employeeOptions = employeesOfDepartment.map((e) => ({
                value: e.id,
                label: e.fullname,
            }));
            this.setState({
                employeeOptions: _employeeOptions,
            });

            this.chartRandom = Math.random(); this.getTitle();
        }


        if (prevState.selectedEmployee !== this.state.selectedEmployee) {
            this.getTpeList(this.state.selectedEmployee);
            this.chartRandom = Math.random();
        }


    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }


    getTpeList = async (employeeId) => {
        let query = `/api/employee-360/tpe-details/${employeeId}`;
        await api
            .get(query)
            .then((response) => {
                this.setState({
                    Tpe: response.data.data.getTpeDetails,
                    Tpematriss: response.data.data.tpematriss,
                    questionSelectionTypes: response.data.data.questionSelectionTypes
                });
            })
            .catch((err) => {
                console.error(err);
            });
        await this.getTitle();
    };

    handleDepartmentSelect = (e) => {
        this.setState({ selectedDepartment: e.value, selectedEmployee: null });
    };

    deparmentOptions = [
        { value: "50020", label: i18n.t("10049") },
        { value: "50021", label: i18n.t("10050") },
        { value: "50022", label: i18n.t("10047") },
        { value: "50023", label: i18n.t("10048") },
    ];

    renderDepartmentCombo = () => {
        return (
            <Select
                placeholder={i18n.t("10521")}
                options={this.deparmentOptions}
                onChange={(e) => this.handleDepartmentSelect(e)}
                value={this.deparmentOptions.find(
                    (o) => o.value === String(this.state.selectedDepartment)
                )}
            />
        );
    };

    handleEmployeeSelect = (e) => {
        this.setState({ selectedEmployee: e.value });
    };

    renderEmployeesCombo = () => {
        return (
            <Select
                placeholder={i18n.t("10521")}
                label="ee"
                options={this.state.employeeOptions}
                onChange={(e) => this.handleEmployeeSelect(e)}
                value={
                    this.state.selectedEmployee
                        ? this.state.employeeOptions.find(
                            (o) => o.value === this.state.selectedEmployee
                        )
                        : null
                }
            />
        );
    };

    renderPosition = () => {
        if (
            this.state.selectedEmployee === null ||
            this.state.selectedEmployee === ""
        )
            return null;
        const employee = this.state.employees.find(
            (z) => z.id === this.state.selectedEmployee
        );
        return <span>{employee.position.name}</span>;
    };

    renderFilterBar = () => {
        if (!this.state.isManager) return null;

        return (
            <div className="row calculateArea">
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
                    <div className="ml-2">
                        <label htmlFor="departmanSeciniz" className='filterHeader'>
                            <Trans desc="Departman Seçiniz">10138</Trans>:
                        </label>
                        {this.renderDepartmentCombo()}
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
                    <div className="ml-2">
                        <label htmlFor="seciliPersonel" className='filterHeader'>
                            <Trans desc="Seçili Personel">10139</Trans>:
                        </label>
                        {this.renderEmployeesCombo()}
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
                    <div>
                        <label htmlFor="seciliPersonel" className="pl-2">
                            <Trans desc="Pozisyon">10140</Trans>:
                        </label>
                        <p id="seciliPersonel" className="mb-0 pl-2 positionName">
                            {this.renderPosition()}
                        </p>
                    </div>
                </div>
            </div>
        );
    };


    getTitle = () => {
        if (this.state.Tpe.length !== 0) {
            if (this.state.group1id != null) {
                const _questionSelectionTypes = this.state.questionSelectionTypes.filter((z) => z.order === "1");
                this.setState({
                    group1name: _questionSelectionTypes[0].name,
                    group1id: _questionSelectionTypes[0].id
                });
            }
            if (this.state.group2id !== null) {
                const _questionSelectionTypes = this.state.questionSelectionTypes.filter((z) => z.order === "2");
                this.setState({
                    group2name: _questionSelectionTypes[0].name,
                    group2id: _questionSelectionTypes[0].id
                });
            }
            if (this.state.group3id !== null) {
                const _questionSelectionTypes = this.state.questionSelectionTypes.filter((z) => z.order === "3");
                this.setState({
                    group3name: _questionSelectionTypes[0].name,
                    group3id: _questionSelectionTypes[0].id
                });
            }
        }
    }


    render() {


        const unique = [...new Set(this.state.Tpe.map((item) => item.gsc_trainingsessionid))];
        return (
            <>
                {this.renderFilterBar()}
                <div className="m-3">
                    {unique.map((rp, idx) => {
                        const first = this.state.Tpe.filter((Tpe) => Tpe.gsc_trainingsessionid === rp)[0];
                        return (
                            <div key={idx}>
                                <div className="row" style={{ "border": "1px solid #a9a8a9", borderRadius: "10px", marginBottom: "15px" }}>
                                    <div className="col-md-6 col-sm-12 col-12" style={{ marginTop: "10px" }}>
                                        <Table className="table display responsive dataTable no-footer dtr-none collapsed table" id="dataTableTplist" >
                                            <thead>
                                                <tr>
                                                    <th colSpan={4} style={{ borderBottom: "1px solid #dee2e6" }}>
                                                        <a style={{ color: "#2d96cd", fontWeight: "bold" }}>

                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-circle" viewBox="0 0 16 16">
                                                                <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                            </svg> {'\u00A0'}

                                                            {first.gsc_employee} </a> <br></br>
                                                        <a style={{ fontWeight: "normal", fontSize: "14px" }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                                                                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                                            </svg> {'\u00A0'}
                                                            {first.gsc_trainingsession} </a> <br></br>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th style={{ fontSize: "14px" }}>
                                                        <Trans>1bolum</Trans>
                                                    </th>
                                                    <DesktopBreakpoint>
                                                        <th style={{ fontSize: "14px" }}>
                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <div> <Trans>2bolum</Trans> </div>
                                                                <div> <Trans>2bolumpuan</Trans> </div>
                                                            </div>
                                                        </th>
                                                        <th style={{ textAlign: "center", fontSize: "14px" }}>
                                                            <Trans>puan</Trans>
                                                        </th>
                                                        <th style={{ textAlign: "center", fontSize: "14px" }} border={1}>
                                                            <Trans>toplam</Trans>
                                                        </th>
                                                    </DesktopBreakpoint>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ fontSize: "13px" }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pin-angle-fill" viewBox="0 0 16 16">
                                                            <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z" />
                                                        </svg> {'\u00A0'}
                                                        {this.state.group1name}</td>
                                                    <td style={{ fontSize: "12px" }} >
                                                        {

                                                            this.state.Tpematriss.filter((matris) => matris.gsc_tpequestionselectiontypeid === this.state.group1id && matris.gsc_employeetpeid === first.gsc_employeetpeid).map((rp1, idx1) => {
                                                                return (
                                                                    <div key={idx1} style={{ display: "flex", justifyContent: "space-between", border: "1px solid rgb(222, 226, 230)", borderRadius: "5px", "color": "rgb(8, 37, 103)", marginBottom: "5px", paddingRight: "5px", paddingLeft: "5px" }}>
                                                                        <div>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                                                                <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                                                                            </svg> {'\u00A0'}  {rp1.gsc_tpequestionselectioncaseName}
                                                                        </div>
                                                                        <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "11px" }}>
                                                                            {rp1.gsc_score} <span style={{ color: "maroon" }}> / {rp1.gsc_maxscore.replace(",", ".")}</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })

                                                        }
                                                    </td>
                                                    <td style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px" }}>
                                                        <div style={{ border: "1px solid #dee2e6", borderRadius: " 10px", color: "#082567" }}>  {first.gsc_score1} / <span style={{ color: "maroon" }}> {first.gsc_maxscore1} </span></div>
                                                    </td>
                                                    <td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px", border: "1px solid #dee2e6" }}>
                                                        <div style={{ display: "flex", placeholder: "center", flexDirection: "column-reverse", flexFlow: "column", justifyContent: "space-around", flexWrap: "wrap", alignContent: "center" }}>
                                                            <div style={{ background: "#85e3ff", border: "3px solid rgb(171 133 187)", justifyContent: "center", alignItems: "center", borderRadius: "100%", textAlign: "center", margin: "5px 20px", fontSize: "18px", fontWeight: "600", padding: "15px", display: "flex", height: "70px", width: "70px", color: "#082567" }}>   {first.gsc_averagescore} </div>
                                                            <div style={{ display: "flex", justifyContent: "space-around", border: "1px solid rgb(222, 226, 230)", borderRadius: "5px", "color": "rgb(8, 37, 103)", marginBottom: "5px", paddingRight: "5px", paddingLeft: "5px", textAlign: "center" }}>
                                                                {first.gsc_successful ? <Trans>basarili</Trans> : <Trans>henuzdegil</Trans>}
                                                            </div>
                                                        </div> </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontSize: "13px" }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pin-angle-fill" viewBox="0 0 16 16">
                                                            <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z" />
                                                        </svg> {'\u00A0'}
                                                        {this.state.group2name}	</td>
                                                    <td style={{ fontSize: "12px" }}>
                                                        {

                                                            this.state.Tpematriss.filter((matris) => matris.gsc_tpequestionselectiontypeid === this.state.group2id && matris.gsc_employeetpeid === first.gsc_employeetpeid).map((rp2, idx2) => {
                                                                return (
                                                                    <div key={idx2} style={{ display: "flex", justifyContent: "space-between", border: "1px solid rgb(222, 226, 230)", borderRadius: "5px", "color": "rgb(8, 37, 103)", marginBottom: "5px", paddingRight: "5px", paddingLeft: "5px" }}>
                                                                        <div>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                                                                <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                                                                            </svg> {'\u00A0'}  {rp2.gsc_tpequestionselectioncaseName}
                                                                        </div>
                                                                        <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "11px" }}>
                                                                            {rp2.gsc_score} <span style={{ color: "maroon" }}> / {rp2.gsc_maxscore.replace(",", ".")}</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })

                                                        }
                                                    </td>
                                                    <td style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px" }}>
                                                        <div style={{ border: "1px solid #dee2e6", borderRadius: "10px", color: "#082567" }}>   {first.gsc_score2} / <span style={{ color: "maroon" }}> {first.gsc_maxscore2} </span> </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontSize: "13px", borderBottom: "1px solid #dee2e6" }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pin-angle-fill" viewBox="0 0 16 16">
                                                            <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z" />
                                                        </svg> {'\u00A0'}
                                                        {this.state.group3name}	</td>
                                                    <td style={{ fontSize: "12px", borderBottom: "1px solid #dee2e6" }}>
                                                        {

                                                            this.state.Tpematriss.filter((matris) => matris.gsc_tpequestionselectiontypeid === this.state.group3id && matris.gsc_employeetpeid === first.gsc_employeetpeid).map((rp3, idx3) => {
                                                                return (
                                                                    <div key={idx3} style={{ display: "flex", justifyContent: "space-between", border: "1px solid rgb(222, 226, 230)", borderRadius: "5px", "color": "rgb(8, 37, 103)", marginBottom: "5px", paddingRight: "5px", paddingLeft: "5px" }}>
                                                                        <div>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                                                                <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                                                                            </svg> {'\u00A0'}  {rp3.gsc_tpequestionselectioncaseName}
                                                                        </div>
                                                                        <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "11px" }}>
                                                                            {rp3.gsc_score} <span style={{ color: "maroon" }}> / {rp3.gsc_maxscore.replace(",", ".")}</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })

                                                        }
                                                    </td>
                                                    <td style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #dee2e6" }}>
                                                        <div style={{ border: "1px solid #dee2e6", borderRadius: "10px", color: "#082567" }}>   {first.gsc_score3} / <span style={{ color: "maroon" }}> {first.gsc_maxscore3} </span> </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <div style={{ marginBottom: "20px" }} ></div>
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-12">
                                        {
                                            <TpeListDetails
                                                gsc_trainingsession={first.gsc_trainingsession}
                                                gsc_score1={first.gsc_score1}
                                                gsc_score2={first.gsc_score2}
                                                gsc_score3={first.gsc_score3}
                                                gsc_maxscore1={first.gsc_maxscore1}
                                                gsc_maxscore2={first.gsc_maxscore2}
                                                gsc_maxscore3={first.gsc_maxscore3}
                                                questionSelectionTypes={this.state.questionSelectionTypes} />
                                        }
                                    </div>
                                </div >
                            </div>
                        );
                    })
                    }
                </div >

            </>
        )
    }

}


const mapStateToProps = (state) => {
    return {
        profile: state.profile,
    };
};

export default connect(
    mapStateToProps,
    {}
)(requireAuth(containsLongRunningProcess(TpeList)));
